/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedTaskOutputObjectivesAnyOf } from './exportedTaskOutputObjectivesAnyOf';

export type ExportedTaskOutputObjectives = ExportedTaskOutputObjectivesAnyOf | null;
